import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  getTransactionCommunicationMessage,
  getTransactionCommunicationMessageAttachments,
} from "../api/transaction-type";
import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
} from "@mui/material";
import {
  commuMessageDialogAttachmentsTable,
  commuMessageDialogReadReceiptsTable,
} from "../config/grid-column-defs";
import AgGridPaginatedTable from "./AgGridPaginatedTable";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../hooks/useSnackbar";
import useErrorHandler from "../hooks/useErrorHandler";
import TabPanel from "./TabPanel";
import { useParams } from "react-router-dom";
import { getTransactionNotAvailable } from "../config/grid-value-formatters";
import DownloadIcon from "@mui/icons-material/Download";
import { getTransactionDownloadfile } from "../api/invoice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle variant="h2" sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function MessagesViewDialog({ open, id, handleClose }) {
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [dialogTabIndex, setDialogTabIndex] = useState(0);
  const [messageDialogData, setMessageDialogData] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [percentComplete, setPercentComplete] = useState(0);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  useEffect(() => {
    getTransactionMessageData(10, 0);
  }, [open]);

  async function getTransactionMessageData(limit, offset) {
    try {
      const { data } = await getTransactionCommunicationMessage(user.token, {
        id: params.docNo,
        messageid: id,
        limit,
        offset,
      });
      setMessageDialogData(data.data.data[0]);
      // return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      // console.log(error);
      // snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  console.log("Progress: ", percentComplete);
  async function getTransactionAttachmentsData(limit, offset) {
    try {
      const { data } = await getTransactionCommunicationMessageAttachments(
        user.token,
        {
          id: id,
          limit,
          offset,
        }
      );
      // setMessageDialogData(data.data.data);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      // console.log(error);
      // snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  let obj = commuMessageDialogAttachmentsTable.find(
    (o) => o.headerName === "DOWNLOAD"
  );
  addAdditionalColumn(obj, dispatch);

  
     const getDownloadDocumentById = (id, filename, folder) => {
        setPercentComplete(0);
    
        const options = {
          headers: {
            authorization: user?.token,
          },
          responseType: "blob",
          onDownloadProgress: function (progressEvent) {
            const newPercentComplete = Math.floor(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            
            console.log(
              "percentage====",
              progressEvent.loaded,
              progressEvent.total
            );
            setPercentComplete(newPercentComplete); // Update the percentComplete state
          },
        };
        setDownloadInProgress(true); // Start the download progress
        getTransactionDownloadfile(
          // { id: id },
    
          options,
          
          { filename: filename, folderpath: folder },
        )
          .then((blob) => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob.data);
            link.setAttribute("download", `${filename.replace(".html",".pdf")}`);
            document.body.appendChild(link);
            link.click();
            setDialogOpen(false);
          })
          .catch((err) => {
            errorHandler(err);
            setDownloadInProgress(false);
            setDialogOpen(false);
          })
          .finally(() => {
            setDownloadInProgress(false);
            setDialogOpen(false);
            // Download completed or errored, stop progress
          });
      };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DOWNLOADVIEW":
        dispatch({ type: "" });
        setDialogOpen(true);
        getDownloadDocumentById(
          dialogAction?.data?.mssg_internal_id,
          dialogAction?.data?.Name,
          dialogAction?.data?.Folder
        );
        break;

      default:
        break;
    }
  }, [dialogAction]);
  return (
    <div className="dialogWidth">
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={open}
        className="dialog-box"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => {
            handleClose();
            setMessageDialogData({});
          }}
          className="closeBtn"
        >
          Email Messages
        </BootstrapDialogTitle>

        <DialogContent dividers>
          {/* body content */}
          <Box className="viewDetilsBox">
            <>
              <Grid container className="mb-2">
                <Grid item xs={12}>
                  <p className="tFormlabel">DATE & TIME</p>
                  <p className="tFormName">{messageDialogData?.date}</p>
                </Grid>
              </Grid>
            </>
          </Box>
          <Box
            className="viewBox sub-tab"
            sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
          >
            <Tabs
              value={dialogTabIndex}
              // onChange={handleChange}
              onChange={(e, nv) => {
                setDialogTabIndex(nv);
              }}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              className="tabs-bkg11 tabs-plr-15"
            >
              <Tab label="Recipients" />
              <Tab label="Message" />
              <Tab label="Attachments" />
              <Tab label="Read Receipts" />
            </Tabs>

            {/* Recipients */}
            <TabPanel value={dialogTabIndex} index={0}>
              <Box className="viewDetilsBox">
                <Grid container className="mb-2">
                  <Grid item xs={12} className="m-b-10">
                    <p className="tFormlabel">FROM</p>
                    <p className="tFormName">{messageDialogData?.Author}</p>
                    {/* <p className="tFormName">{messageDialogData?.Author+" "+messageDialogData?.author_email}</p> */}

                  </Grid>
                  <Grid item xs={12} className="m-b-10">
                    <p className="tFormlabel">RECIPIENT</p>
                    <p className="tFormName"style={{overflowWrap: "anywhere"}}>
                      {messageDialogData?.primary_recipient+" "+messageDialogData?.to}
                    </p>
                  </Grid>
                  <Grid item xs={12} className="m-b-10">
                    <p className="tFormlabel">CC</p>
                    <p className="tFormName" style={{overflowWrap: "anywhere"}}>{messageDialogData?.cc}</p>
                  </Grid>
                  <Grid item xs={12} className="m-b-10">
                    <p className="tFormlabel">BCC</p>
                    <p className="tFormName wordBreakAll">
                      {messageDialogData?.bcc}
                    </p>
                  </Grid>
                </Grid>
              </Box>
            </TabPanel>
            {/* Recipients */}

            {/* Message */}
            <TabPanel value={dialogTabIndex} index={1}>
              <Box className="viewDetilsBox">
                <Grid container className="mb-2">
                  <Grid item xs={12} className="m-b-10">
                    <p className="tFormlabel">SUBJECT</p>
                    <p className="tFormName">{messageDialogData?.Subject}</p>
                  </Grid>
                  <Grid item xs={12} className="m-b-10">
                    <p className="tFormlabel">MESSAGE</p>
                    <p className="tFormName">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: messageDialogData?.message,
                        }}
                      />
                    </p>
                  </Grid>
                </Grid>
              </Box>
            </TabPanel>
            {/* Message */}

            {/* Attachments */}
            <TabPanel value={dialogTabIndex} index={2}>
              <Box className="viewDetilsBox">
                <AgGridPaginatedTable
                  getTableRows={getTransactionAttachmentsData}
                  columns={commuMessageDialogAttachmentsTable}
                  perPage={2}
                  refreshCounter={0}
                />
              </Box>
             <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
               <DialogTitle>Download Progress</DialogTitle>
               <DialogContent>
                 {downloadInProgress ? (
                   <>
                     <CircularProgress
                      variant="indeterminate"  
                       value={percentComplete}
                       size={50}
                       thickness={10}
                       style={{ marginLeft: "65px" }}
                     />
                     <Box 
                       sx={{
                         marginTop: 2, 
                         textAlign: "center", 
                         fontSize: "16px", 
                         color: "#333",
                         "&:hover": {
                           color: "#1976d2",
                           cursor: "pointer",
                         }
                       }}
                     >
                       <span>Please wait...</span>
                     </Box>
                   </>
                 ) : (
                   <></>
                 )}
               </DialogContent>
               {/* Add dialog actions here if needed */}
             </Dialog>
            </TabPanel>
            {/* Attachments */}

            {/* Read Receipts */}
            <TabPanel value={dialogTabIndex} index={3}>
              <Box className="viewDetilsBox">
                <AgGridPaginatedTable
                  getTableRows={getTransactionNotAvailable}
                  columns={commuMessageDialogReadReceiptsTable}
                  perPage={2}
                  refreshCounter={0}
                />
              </Box>
            </TabPanel>
            {/* Read Receipts */}
          </Box>
          {/* body content */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
              setMessageDialogData({});
              setDialogTabIndex(0);
            }}
            className="backBtn"
          >
            Cancel
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    commuMessageDialogAttachmentsTable.push({
      headerName: "DOWNLOAD",
      field: "actions",
      minWidth: 100,
      cellClass: "downloadCenter",
      cellRendererFramework: (params) => (
        <Box>
          <Button
            title=""
            className="actionIcon"
            onClick={() => {
              dispatch({ type: "DOWNLOADVIEW", data: params.data });
            }}
          >
            <DownloadIcon />
          </Button>
        </Box>
      ),
    });
  }
}
